import resourceService from '../services/resources'
import resourcesService from '../services/resourceService'
import { createSlice } from '@reduxjs/toolkit'

import { setErrorNotification } from './notificationReducer'

const initialState = null

const resourceSlice = createSlice({
    name: 'resources',
    initialState,
    reducers: {
        setResources(state, action) {
            return action.payload
        },
        changeResource(state, action) {
            if (state === null) return state
            return state.map((resource) => (resource.id === action.payload.id && resource.type === action.payload.type) ? action.payload : resource)
        },
        destroyResource(state, action) {
            if (state === null) return state
            return state.filter(resource => (resource.id !== action.payload.id || resource.type !== action.payload.type))
        }
    }
})

export const { setResources, changeResource, destroyResource } = resourceSlice.actions

export const initializeResources = () => {
    return async dispatch => {
        try {
            const resources = await resourceService.retrieve()
            dispatch(setResources(resources))
        } catch {
            dispatch(setErrorNotification('Error retrieving resources'))
        }
    }
}

export const searchResources = (query) => {
    return async dispatch => {
        try {
            const resources = await resourceService.retrieve(query)
            dispatch(setResources(resources))
        } catch {
            dispatch(setErrorNotification('Error fulfilling search'))
        }
    }
}

export const refreshResource = (id) => {
    return async dispatch => {
        try {
            const resource = await resourcesService.retrieveSingle(id)
            dispatch(changeResource(resource))
        } catch { }
    }
}

export default resourceSlice.reducer
